import { render, staticRenderFns } from "./SOGR.vue?vue&type=template&id=33c7aa2c&"
import script from "./SOGR.vue?vue&type=script&lang=js&"
export * from "./SOGR.vue?vue&type=script&lang=js&"
import style0 from "./SOGR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c7aa2c')) {
      api.createRecord('33c7aa2c', component.options)
    } else {
      api.reload('33c7aa2c', component.options)
    }
    module.hot.accept("./SOGR.vue?vue&type=template&id=33c7aa2c&", function () {
      api.rerender('33c7aa2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/SOGR.vue"
export default component.exports